import { render, staticRenderFns } from "./BpIngredientFilter.vue?vue&type=template&id=1e00e807&"
import script from "./BpIngredientFilter.vue?vue&type=script&lang=js&"
export * from "./BpIngredientFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports